import React, { Component } from 'react'
import DatePicker from 'react-date-picker'
import './Calendar.scss'
import moment from 'moment'
import { withTranslation } from 'react-i18next'

//TODO: display validation errors
class CalendarField extends Component {
  static defaultProps = {
    input: {},
    meta: {},
    maxDate: undefined,
    minDate: undefined,
  }

  render() {
    const { input, meta, label, i18n } = this.props
    const errorClass = meta.touched && meta.error && 'invalid'
    //TODO: find a way to rehidrate redux-form with Date objects not strings
    let date = input.value
    if (date && typeof date === 'string') date = moment(date).toDate()

    return (
      <div className={`calendar-picker md-field ${errorClass}`}>
        {label && <label style={{ display: 'block' }}>{label}</label>}
        <DatePicker
          {...this.props}
          onBlur={() => input.onBlur()}
          onFocus={() => input.onFocus()}
          value={date}
          onChange={input.onChange}
          clearIcon={null}
          locale={i18n.language}
        />
      </div>
    )
  }
}
export default withTranslation()(CalendarField)
